import { useEffect } from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionTitle({ kicker, title, className = "" }) {
  return (
    <div className={className}>
      {kicker && <p className="overline mb-2">{kicker}</p>}
      <h2 className="font-display font-extrabold text-2xl md:text-3xl">{title}</h2>
      <div className="mt-3 h-px w-16 bg-gradient-to-r from-rose-500 to-transparent" />
    </div>
  );
}

export function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
      m.content = description;
    }
    return () => { document.title = "Gulf Coast VIP"; };
  }, [title, description]);
}
